module.exports = __webpack_public_path__ + "static/media/m_beard_shortboxed_round__oval_vector.6a344aae.svg";